const UNTYPED_COST_SHARE_OF_SELL = 0.8;

/**
 * Margin as a fraction of the AUD sell, blank rather than 0 when the sell is unusable. An untyped
 * cost (null) falls back to 80% of sell, but a typed 0 is a real cost, so the two must not be collapsed.
 */
export function computeSurchargeMargin(sellAud: number, costAud: number | null): number | null {
  if (!Number.isFinite(sellAud) || sellAud <= 0) {
    return null;
  }
  const cost = costAud == null || !Number.isFinite(costAud) ? UNTYPED_COST_SHARE_OF_SELL * sellAud : costAud;
  return 1 - cost / sellAud;
}
